import React from 'react'

interface BackdropProps {
  onClick: () => void;
}

const Backdrop = ({onClick}: BackdropProps) =>
  <div
    className="fixed w-full h-full top-0 left-0 opacity-30 bg-black z-[100]"
    onClick={onClick}
  />

export default Backdrop
